/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CandidateDestroyByEmailQueryParams,
	CandidateDestroyByEmailResponse,
} from '../types/CandidateDestroyByEmail'

/**
 * DELETE /candidates/by-email
 * @see backend/nexus/modules/Campaign/Http/Controllers/CandidateController.php CandidateController::destroyByEmail
 */
export async function candidateDestroyByEmail(
	params?: CandidateDestroyByEmailQueryParams,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CandidateDestroyByEmailResponse>> {
	return axiosInstance.delete('/candidates/by-email', { params, ...config })
}
